module.exports = __webpack_public_path__ + "static/media/icon-pricing.2b50126d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/icon-pricing.svg
// module id = 393
// module chunks = 0